module.exports = __webpack_public_path__ + "static/media/team-introduction-4.a0027115.jpg";